const { auto } = require("@popperjs/core");

(function($) {

	// Initialize slider on mobile only
	$(window).on('load resize orientationchange', function() {
		$('.slick-slider').slick('setPosition');
		$('.slider-mobile').each(function() {
			var $carousel = $(this);

			if ($(window).width() > 752) {
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}
			}
			else {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						arrows: false,
						dots: true,
						fade: true,
						infinite: false,
						mobileFirst: true,
						slide: '.slider-item',
						slidesToScroll: 1,
						slidesToShow: 1,
					})
				}
			}

		});
	});

}(jQuery));

// Sets slider height on load
$(window).on('load', function() {
	$('.slick-slider').slick('setPosition');
});


(function($) {

	var numSlick = 0;

	// Initialize logo sliders
	$('.slider-logos').each( function() {
		numSlick++;

		$(this).addClass( 'slider-' + numSlick ).slick({
			accessibility: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2000,
			dots: false,
			infinite: true,
			slide: '.slider-item',
			slidesToScroll: 1,
			slidesToShow: 6,
			speed: 2000,
			cssEase: 'linear',
			responsive: [
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 5,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 374,
				settings: {
					slidesToShow: 1,
				}
			}
			]

		})

	});

	// Refresh nested slider on tab change
	$('.tab-block a[data-toggle="pill"]').on('shown.bs.tab', function(e) {

		// Grab tab target
		var tabTarget = $(this).attr('href');

		$(tabTarget)
			.find('.slider-logos')
			.slick('refresh');

	});

}(jQuery));


(function($) {

	var numSlick = 0;

	// Initialize testimonial sliders
	$('.slider-testimonials').each( function() {
		numSlick++;

		$(this).addClass( 'slider-' + numSlick ).slick({
			accessibility: false,
			arrows: true,
			dots: true,
			fade: true,
			infinite: false,
			slide: '.slider-item',
			slidesToScroll: 1,
			slidesToShow: 1,
		})

	});

}(jQuery));


(function($) {

	var numSlick = 0;

	// Initialize testimonial sliders
	$('.image-slider').each( function() {
		numSlick++;

		$(this).addClass( 'slider-' + numSlick ).slick({
			accessibility: false,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			dots: true,
			fade: true,
			infinite: true,
			slide: '.slider-item',
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 800,
			waitForAnimate: false,
		})

	});

}(jQuery));


(function($) {

	// Initialize hero sliders
	$('.slider-hero').slick({
		accessibility: false,
		//adaptiveHeight: true,
		arrows: false,
		asNavFor: '.slider-nav',
		autoplay: false,
		dots: false,
		fade: true,
		infinite: true,
		slide: '.slider-item',
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 800,
	})
	.on('setPosition', function (event, slick) {
		slick.$slides.css('height', slick.$slideTrack.height() + 'px');
	});

	// Initialize hero sliders
	$('.slider-nav').slick({
		accessibility: false,
		arrows: false,
		asNavFor: '.slider-hero',
		focusOnSelect: true,
		slide: '.slider-item',
		slidesToScroll: 1,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					dots: true,
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 576,
				settings: {
					dots: false,
					slidesToShow: 1,
				}
			},
			]
	});


	// Animated progress bar
	var percentTime;
	var tick;
	var time = 1;
	var progressBarIndex = 0;

	$('.slider-nav .progress-bar').each(function(index) {
		var progress = "<div class='in-progress in-progress" + index + "'></div>";
		$(this).html(progress);
	});

	function startProgressbar() {
		resetProgressbar();
		percentTime = 0;
		tick = setInterval(interval, 10);
	}

	function interval() {
		if (($('.slider-hero .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
			progressBarIndex = $('.slider-hero .slick-track div[aria-hidden="false"]').data("slickIndex");
			startProgressbar();
		} else {
			percentTime += 1 / (time + 5);
			$('.in-progress' + progressBarIndex).css({
				width: percentTime + "%"
			});
			if (percentTime >= 100) {
				$('.single-item').slick('slickNext');
				progressBarIndex++;
				if (progressBarIndex > 2) {
					progressBarIndex = 0;
				}
				startProgressbar();
			}
		}
	}

	function resetProgressbar() {
		$('.in-progress').css({
			width: 0 + '%'
		});
		clearInterval(tick);
	}
	startProgressbar();
	// End ticking machine

	$('.slider-nav div').click(function () {
		clearInterval(tick);
		var goToThisIndex = $(this).find("span").data("slickIndex");
		$('.single-item').slick('slickGoTo', goToThisIndex, false);
		startProgressbar();
	});


	$(window).on('load resize orientationchange', function () {
        $('.card-slider').each(function () {
            var $carousel = $(this);
            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    arrows: true,
                    accessibility: false,
                    dots: true,
                    respondTo: 'window',
                    slide: '.slider-item',
                    autoplay: false,
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    // appendDots: $(".slide-m-dots"),
                    // prevArrow: $(".slide-m-prev"),
                    // nextArrow: $(".slide-m-next"),
                    responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 3,
							}
						},
                        {
                            breakpoint: 993,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        },
						{
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        },
                    ]
                })
				/*Adds inline height on slide for equal height setup*/
				.on('setPosition', function (event, slick) {
					// $carousel.slick('refresh');
					// slick.$slides.css('height', slick.$slideTrack.height() + 'px');
				});
            }
        });
    });

    // Sets width of slider nested inside of tabs
    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        $('.slick-slider').slick('setPosition');
    });


	// Setup custom slider
    $(document).on('ready', function() {
        $('.custom-slider').each(function() {
			var $this = $(this);
			$(this).imagesLoaded(function() {
            	setSpeed($this);
			});
        });
    });
    $(window).on('resize', function() {
        $('.custom-slider').each(function() {
            setSpeed($(this));
        });
    });

    // Start slider on tab click
    // $('button[data-bs-toggle="pill"]').on('shown.bs.tab', function(e) {
    //     var targetID = $(e.target).attr('data-bs-target'),
    //         $tabTarget = $(targetID);
            
    //     if ($tabTarget.find('.custom-slider').length > 0) {
    //         setSpeed($tabTarget.find('.custom-slider'));
    //     }
    // });

    function setSpeed(slider) {
        // get the width of the slider group and set the animation speed based off the perPixel variable
        var perPixel = 130; // Speed in pixels per second

        if($(window).width() < 768) {
            perPixel = 80;
        }

        var $sliderGroup = slider.find('.slider-group'),
            sliderWidth = $sliderGroup.width(),
            animationSpeed = sliderWidth / perPixel * 1000;

		if(animationSpeed < 10000) {
			animationSpeed = $sliderGroup.find('.slider-item').length * 100 / 130 * 1000;
		}
        
        // Set the animation speed
        $sliderGroup.css('animation-duration', animationSpeed + 'ms');
    }


}(jQuery));


